import React, { useState } from "react";
import { ErrorScope, Modal, Spinner } from "acma-spa";;
export interface ContentModalProps {
  title: string
  open: boolean
  onClose: () => any
  spinnerText: string
  onConfirm: () => Promise<any>
}

export const ContentModal: React.FC<ContentModalProps> = (props) => {
  const [error, setError] = useState<string|undefined>(undefined);
  const [spinner, setSpinner] = useState<string>("");

  const onConfirm = async () => {
    try {
      setSpinner(props.spinnerText);

      await props.onConfirm();

      props.onClose();
    }
    catch(e: any) {
      setError(e.message ? e.message : "Unexpected error");
    }
    finally {
      setSpinner("");
    }
  }

  return <>
    {props.open ? <Modal id="contentModal" open={true} size="lg" onClose={() => !spinner && props.onClose()} title={props.title} leftButtons={[
      {
        label: "Confirm",
        id: "confirm",
        onClick: () => onConfirm(),
        disabled: spinner ? true: false
      },
      {
        label: "Cancel",
        id: "cancel",
        onClick: () => props.onClose(),
        mode: 'secondary'
      }
    ]}>
      <div id="contentContainer" className="mb-2">
        <Spinner isLoading={spinner ? true : false} loadingText={spinner}>
          {props.children}
        </Spinner>
      </div>
      <ErrorScope id="error" error={error} />
    </Modal> : <></>}
  </>
}